import { object, string } from "yup";

let choosePlanSchema = object({
  website: string().required("Website cannot be empty."),
  plan: string().required("Plan cannot be empty."),
  billed_type: string().required("Street cannot be empty."),
});

export default choosePlanSchema;
